export const TOGGLE_SEARCH = 'TOGGLE_SEARCH';
export const SEARCH_CLOSED = 'SEARCH_CLOSED';
